export const formatoCatalogos = (catalogos) => {
  const catalogosConFormato = catalogos;
  catalogosConFormato.usuariosFiscalizacion = catalogosConFormato.usuariosFiscalizacion.map(
    (usuario) => {
      return {
        ...usuario,
        nombreCompleto: `${usuario.nombre} ${usuario.apPaterno} ${usuario.apMaterno}`,
        nombreCompletoPuesto: `${usuario.nombre} ${usuario.apPaterno} ${usuario.apMaterno} / ${usuario.puesto}`
      };
    }
  );
  return catalogosConFormato;
};
